@if (visible) {
  <aside class="post-banner">
    <div class="post-banner-head">
      <mat-icon class="post-banner-icon">stars</mat-icon>
      <p class="post-banner-text">{{ 'post.bannerText' | t }}</p>
      <a class="post-banner-how" routerLink="/compte/club">{{ 'post.bannerHow' | t }}</a>
      <a class="btn-pill btn-pill-accent post-banner-cta" routerLink="/poster">{{ 'header.post' | t }}</a>
      <button type="button" class="post-banner-close" [attr.aria-label]="'common.close' | t" (click)="dismiss()">
        <mat-icon>close</mat-icon>
      </button>
    </div>
    <form class="post-banner-form" (ngSubmit)="submit()">
      <input name="url" type="url" dir="ltr" class="post-banner-input" [(ngModel)]="url" (ngModelChange)="error = ''"
        [placeholder]="'post.urlPlaceholder' | t" [attr.aria-label]="'post.urlLabel' | t" autocomplete="off" inputmode="url" />
      @if (canPaste) {
        <button type="button" class="btn-pill btn-pill-outline" (click)="pasteLink()">
          <mat-icon>content_paste</mat-icon>{{ 'post.paste' | t }}
        </button>
      }
      <button type="submit" class="btn-pill btn-pill-accent">{{ 'post.analyze' | t }}</button>
    </form>
    @if (error) { <p class="post-banner-error" role="alert">{{error}}</p> }
  </aside>
}
